import { useAuthApp } from "../app/auth";
import axios from './axios';
import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';
import Swal from "sweetalert2";
import { REACT_APP_API_BASE_URL } from "./constant";
import axiosPublic from './axios_public';

const Toast = Swal.mixin({
    toast:true,
    position:"top",
    showConfirmButton:false,
    timer:1500,
    timerProgressBar: true
})

export const login = async (email, password) => {
    try {
        const {data, status} = await axiosPublic.post(`${REACT_APP_API_BASE_URL}user/token/`, {
            email,
            password
        })
        if(status === 200){
            setAuthUser(data.access, data.refresh);

            // Alert - Sign In Successfully
            Toast.fire({
                icon:"success",
                title:"Login Successful"
            })
        }
        return {data, error: null}

    } catch (error) {
        console.log(error);
        // console.log('ERROR RESPONSE DATA ==== ', error.response.data)
        return {
            data: null,
            error: error.response.data?.detail || 'Something went wrong'
        };
    }
}

export const register = async (userData) => {
    try {
        const {data} = await axiosPublic.post(`${REACT_APP_API_BASE_URL}user/register/`, {
            first_name: userData.firstName,
            last_name: userData.lastName,
            email: userData.email,
            password: userData.password,
            password2: userData.password2,
            winefactsprofile: {
                winery: userData.winefactsprofile.winery,
                acceptance: userData.winefactsprofile.acceptance,
                img_qr_code: userData.winefactsprofile.imgQrCode
            },
            recaptcha_token: userData.recaptcha_token
        },
        {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            timeout: 20000, // 20 seconds timeout
          }
        );
        // TODO: Email Verification
        // await login(userData.email, userData.password)

        // Alert - Signed up Successfully
        Toast.fire({
            icon:"success",
            title:"Account created successfully"
        })
        return { data, error: null}

    } catch (error) {
        console.log(error);
        return {
            data: null,
            error: error.response.data?.detail || 'Something went wrong'
        };
    }
}


export const logout = () => {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    useAuthApp.getState().setUser(null);
}

export const setUser = async () => {
    const accessToken = Cookies.get("access_token");
    const refreshToken = Cookies.get("refresh_token");

    if(!accessToken || !refreshToken) {
        useAuthApp.getState().setUser(null);
        return;
    }

    if(isAccessTokenExpired(accessToken)){
        const response = await getRefreshToken(refreshToken);
        setAuthUser(response.access, response.refresh);
    } else {
        setAuthUser(accessToken, refreshToken);
    }
}


export const setAuthUser = (accessToken, refreshToken) => {
    Cookies.set("access_token", accessToken, {
        expires: 1, // 1 day
        secure: import.meta.env.DEV ? false : true, //set if https only
    })

    Cookies.set("refresh_token", refreshToken, {
        expires: 7, // 7 days
        secure: import.meta.env.DEV ? false : true, //set if https only
    })

    const user = jwt_decode(accessToken) ?? null
    
    if (user){
        useAuthApp.getState().setUser(user)
    }
    useAuthApp.getState().setLoading(false)
}

export const getRefreshToken = async () => {
    const refresh_token = Cookies.get("refresh_token")
    const response = await axios.post(`${REACT_APP_API_BASE_URL}user/token/refresh/`,{
         refresh: refresh_token
    })
    return response.data
}

// in django backend urls.py add from rest_framework: from rest_framework_simplejwt.views import TokenRefreshView; path('user/token/refresh/', TokenRefreshView.as_view()); 

export const isAccessTokenExpired = (accessToken) => {
    try {
        const decodedToken = jwt_decode(accessToken)
        return decodedToken.exp < Date.now() / 1000
    } catch (error) {
        console.log(error)
        return true
    }
}